export const downloadImage = async (url: string) => {
  const fetch = (await import('node-fetch')).default
  const res = await fetch(url)
  if (!res.ok) throw new Error(`Failed to fetch ${url}: ${res.statusText}`)
  const contentType = res.headers.get('content-type')
  const buffer = await res.buffer()
  const filename = url.split('/').pop()
  return { buffer, contentType, filename }
}
